import qs from 'qs'
import { logout } from './login.js'

export async function getFollowArticleIds(state, axios) {
  let route, headers
  if (localStorage.getItem(state.storageKeys.identity) == 'partners') {
    route = state.URLs.apiPartner + state.routes.followingArticleIds
    headers = {
      "X-Line-Biz-Session": localStorage.getItem(state.storageKeys.token),
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }
  else {
    route = state.URLs.api + state.routes.followingArticleIds
    headers = {
      "Authorization": "Bearer " + localStorage.getItem(state.storageKeys.token)
    }
  }
  return axios.get(route, { headers: headers })
  .then(result => {
    return result.data
  })
  .catch(error => {
    if (error.response.status == "403")
      logout(state)
  })

}

export async function followArticle(type, state, axios, articleId) {
  let identity = localStorage.getItem(state.storageKeys.identity)
  if (identity == 'partners') {
    let route = state.URLs.apiPartner + '/partners/' + type + 'Article'
    return axios.post(route,
      qs.stringify({ articleId: articleId }), {
      headers: {
        "X-Line-Biz-Session": localStorage.getItem(state.storageKeys.token),
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then()
    .catch(error => {
      if (error.response.status == "403")
        logout(state)
    })
  }
  else {
    let route = state.URLs.api + '/users/' + type + '?articleId=' + articleId
    return axios.put(route, {}, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem(state.storageKeys.token)
      }
    })
    .then()
    .catch(error => {
      if (error.response.status == "403") {
        logout(state)
      }
    })
  }
}

export async function verifyRecaptcha(state, recaptchaResponse, axios) {
  let route = state.URLs.api + '/recaptcha?g-recaptcha-response=' + recaptchaResponse
  return await axios.post(route)
}
